import BulkOrderCardDesignsIndexPage from '../../../components/pages/bulk_order/card_designs/BulkOrderCardDesignsIndexPage.vue'
export default {
  components: { BulkOrderCardDesignsIndexPage }
}
